import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Coordinates } from '@awesome-cordova-plugins/geolocation/ngx';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
import { AttivitaReale } from '../models/didattica/attivita-reale';
import { Corso } from '../models/didattica/corso';
import { Docente } from '../models/didattica/docente';
import { Studente } from '../models/didattica/studente';
import { StudenteEnanche } from '../models/didattica/studente-enanche';
import { StudenteIscrInfo } from '../models/didattica/studente-iscr-info';
import { StudenteProgress } from '../models/didattica/studente-progress';
import { ImpegnoDocente } from '../models/impegno-docente.models';
import { ConteggiRilevazione } from '../models/rilevazione-presenze/conteggi-rilevazione';
import { Delega } from '../models/rilevazione-presenze/delega';
import { Presenza, StatoPresenza } from '../models/rilevazione-presenze/presenza';
import { ModalitaErogazione, Rilevazione, StatoRilevazione } from '../models/rilevazione-presenze/rilevazione';
import { Prenotato } from '../models/student-booking.models';
import { Utente } from '../models/utente';
import { ConfigService } from './config-service/config-service';
import { PlatformName } from './env-service/env-platform';
import { EnvService } from './env-service/env-service';
import { GeolocUtilityService } from './geolocutility.service';
import { UserService } from './user-service';
import { UtilityService } from './utility.service';
import { AbscenceJustificationModel, AbsenceRequestBodyModel, AbsenceRequestStatus } from '../models/rilevazione-presenze/absence.model';

/**
 * Il servizio core della rilevazione presenze
 */
@Injectable( { providedIn: 'root' })
export class RilevazionePresenzeService {


  optionsContJson = {headers: new HttpHeaders({'Content-Type':  'application/json'})};
  cdsList = this.configService.getConfigurazione(ChiaveConfig.CDS_LIST_REDUCED_HOURS).split(',');

  constructor(public http: HttpClient
    , private userService: UserService
    , private translateService: TranslateService
    , private envService: EnvService
    , private platform: Platform
    , private geolocUtilityService: GeolocUtilityService
    , private utilityService: UtilityService
    , public configService: ConfigService) {
    console.log('Hello RilevazionePresenzeService Provider');

  }

  public getReport(filter): Observable<any> {
    const corso = filter.corso || '';
    const docente = filter.docente || '';
    const da = filter.dataDa || '';
    const a = filter.dataA || '';
    const reportkind = filter.reportkind || '';
    const idInsegnamento = filter.idInsegnamento || '';
    const matricola = filter.matricola || '';
    const sede = filter.sede || '';
    const anno = filter.anno || '';
    const semestre = filter.semestre || '';
    const integ = filter.integ;
    let full = filter.full;

    if(full == null) {
      full = true;
    }

    console.log('reportkind', reportkind);
      // frequenze
      if ( reportkind === 'freqs' ) {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`presenze/frequenze?idDocente=${docente}&idCorso=${corso}&dataDa=${da}&dataA=${a}&idInsegnamento=${idInsegnamento}`,
                              {responseType: 'text'});
      } else if ( reportkind === 'preswtot' || reportkind === 'presmatrwtot') {
        // tslint:disable-next-line:max-line-length
        const url = `presenze/report?idDocente=${docente}&idCorso=${corso}&dataDa=${da}&dataA=${a}&idInsegnamento=${idInsegnamento}&matricola=${matricola}&anno=${anno}&sede=${sede}&full=${full}&semestre=${semestre}&integ=${integ}`;
        return this.http.get(url, {responseType: 'text'});
      } else if ( reportkind === 'pres' || reportkind === 'presmatr' ) {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`presenze/fullReport?idDocente=${docente}&idCorso=${corso}&dataDa=${da}&dataA=${a}&idInsegnamento=${idInsegnamento}&matricola=${matricola}&anno=${anno}&sede=${sede}`,
                                {responseType: 'text'});
      } else if ( reportkind === 'contacts' ) {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`presenze/contacts?dataDa=${da}&dataA=${a}&matricola=${matricola}`,
                                {responseType: 'text'});
      } else if ( reportkind === 'rils' ) {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`rilevazioni/fullReport?idDocente=${docente}&idCorso=${corso}&dataDa=${da}&dataA=${a}&anno=${anno}&sede=${sede}`,
                                {responseType: 'text'});
      } else if ( reportkind === 'richiestegiustificativi' ) {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`presenze/ricGiust?dataDa=${da}&dataA=${a}&anno=${anno}`,
                                {responseType: 'text'});
      } else {
        // tslint:disable-next-line:max-line-length
        return this.http.get(`presenze/fullReport?idDocente=${docente}&idCorso=${corso}&dataDa=${da}&dataA=${a}&idInsegnamento=${idInsegnamento}&sede=${sede}`,
                                {responseType: 'text'});
      }
  }

  // stampaRilevazione(iul: string): Observable<any> {
  //   console.log('stampaRilevazione');
  //   return this.http.get('reports/iul/' + iul,
  //   {responseType: 'blob'});
  // }
  stampaRilevazione(iul: string): Observable<any> {
    console.log('stampaRilevazione');
    return this.http.get('reports/iul/' + iul,
    {responseType: 'blob'});
  }

  stampaRiepilogo(report: string, filtroData: string): Observable<any> {
    let queryParams = '';
    filtroData = filtroData.split('T')[0];
    queryParams = `?filtroData=${filtroData}`;
    console.log('stampaRiepilogo: ' + report);
    return this.http.get('reports/riepiloghi/' + report + queryParams,
    {responseType: 'blob'});
  }

  stampaDettaglioPerAR(idAR: string): Observable<any> {
    console.log('stampaDettaglioPerAR id: ' + idAR);
    return this.http.get('reports/ar/' + idAR,
    {responseType: 'blob'});
  }

  stampaDettaglioPerARStu(idAR: string, idStu: string): Observable<any> {
    console.log('stampaDettaglioPerARStu id: ' + idAR );
    return this.http.get('reports/dettaglioarstu/ar/' + idAR + '/studente/' + idStu,
    {responseType: 'blob'});
  }

  stampaRegistroPresenzeAR(idAR: string): Observable<any> {
    console.log('stampaRegistroPresenzeAR id: ' + idAR);
    return this.http.get('reports/ar/' + idAR + '/registro',
    {responseType: 'blob'});
  }

  rilevazioneCode(ril: Rilevazione): Observable<any> {
    return this.http.get(`rilevazioni/docente/qrcode/request?idRilevazione=${ril.id}`)
    .pipe(
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      })
    );
  }
  cercaRilevazione(iul: string, loadAddress = true ): Observable<Rilevazione> {
    // const loadAddress = true;
    return this.http.get('rilevazioni/iul/' + iul).pipe(
      map(r => this.parseRilevazioneResponse(r, loadAddress).pop()),
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      }));
  }

  cercaRilevazionePerIul(iul: string, all = 'ALL'): Observable<Rilevazione[]> {
    return this.http.get('rilevazioni/iul/' + iul + '/' + all)
    .pipe(map(r => this.parseRilevazioneResponse(r)),
    catchError(error => {
      if (error.status === 404) {
        return of(undefined);
      } else {
        throwError(() => new Error(error));
      }
    }
));
  }


  cercaRilevazioniDocente(d: Docente, anno: string): Observable<Rilevazione[]> {
    return this.http.get('rilevazioni/docente/' + d.id + '/' + anno)
      // .pipe(map(r => r.json())
      .pipe(map(r => this.parseRilevazioneResponse(r)));
  }

  cercaAnnoSolareMin(docId: number): Observable<number> {
    return this.http.get<string>('rilevazioni/' + docId + '/annosolareminimo')
      .pipe(map(r => parseInt(r, 10)));
  }

  cercaAnnoOffertaMin(docId: number): Observable<number> {
    return this.http.get<string>('rilevazioni/' + docId + '/annooffertaminimo')
      .pipe(map(r => parseInt(r, 10)));
  }

  countRilevazioneAttivaDocente(d: Docente): Observable<number> {
    return this.http.get<string>('rilevazioni/docente/v2/' + d.id + '/contaattive')
      .pipe(map(r => parseInt(r, 10)));
  }


  countRilevazioneAttivaDocenteAsDelegato(d: Docente): Observable<number> {
    return this.http.get<string>('rilevazioni/docente/' + d.id + '/contaattive/delegato')
      .pipe(map(r => parseInt(r, 10)));
  }

  cercaRilevazioneAttivaDocente(d: Docente, delegata: string): Observable<Rilevazione> {
  return this.http.get('rilevazioni/docente/v2/' + d.id + '/attiva/' + delegata).pipe(
  // const iul = 'UEHKS';
  // return this.http.get('rilevazioni/iul/' + iul).pipe(
    map(r => this.parseRilevazioneResponse(r).pop()),
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      }));
  }

  countRilevazioniAttiveStudente(s: Studente): Observable<number> {
    return this.http.get<string>('rilevazioni/studente/' + s.id + '/contaattive')
      .pipe(map(r => parseInt(r, 10)));
  }

  cercaRilevazioneAttivaStudente(s: Studente): Observable<Rilevazione> {
    return this.http.get(`rilevazioni/studente/${s.id}/attiva`).pipe(
      map(r => this.parseRilevazioneResponse(r).pop()),
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      }));
  }

  modificaRilevazione(rilevazione: Rilevazione, moveMarcature: boolean): Observable<Rilevazione> {
    const moveM = moveMarcature ? 'S' : 'N';
    // rilevazione.istanteCreazione = istanteCreazione;
    if (rilevazione.ar) {
      rilevazione.ar.rilevazioni = undefined;
    }
    const s = JSON.stringify(rilevazione);
    console.log(s);
    return this.http.put(`rilevazioni/modifica/${moveM}`, s, this.optionsContJson)
      .pipe(map(r => this.parseRilevazioneResponse(r).pop()));
  }

  creaDelegaDaAR(ar: AttivitaReale, usePreviousYear: boolean, docente: Docente): Observable<Delega> {

    const post = {
      'idAttivitaReale': ar.id,
      'idDocente': docente.id,
      'usePreviousYear': usePreviousYear
    };

    return this.http.put('deleghe/', JSON.stringify(post),  this.optionsContJson)
      .pipe(map(r => this.parseDelegaResponse(r).pop()));
  }

  associaDocenteDelega(delega: Delega, docente: Docente): Observable<Delega> {
    const post = {
      iul: delega.iul,
      idDelegato: docente.id
    };
    return this.http.put('deleghe/associa', JSON.stringify(post),  this.optionsContJson)
      .pipe(map(r => this.parseDelegaResponse(r).pop()));
  }

  creaRilevazioneDaDelega(delega: Delega, usePreviousYear: boolean, coords?: Coordinates): Observable<Rilevazione> {

    const post = {
      iul: delega.iul,
      idDelegato: this.userService.getDocenteCorrente().id,
      idDocente: delega.docente.id,
      durataRil: delega.durataRil,
      latitudine: coords ? coords.latitude : undefined,
      longitudine: coords ? coords.longitude : undefined,
      usePreviousYear: usePreviousYear,
      note: delega.note
    };

    return this.http.put('deleghe/attiva', JSON.stringify(post),  this.optionsContJson)
      .pipe(map(r => this.parseRilevazioneResponse(r).pop()));
  }

  cercaDelega(iul: string, anno: string): Observable<Delega> {
    return this.http.get('deleghe/iul/v2/' + anno + '/' + iul).pipe (
        map(r => this.parseDelegaResponse(r).pop())
      );
  }

  cercaDeleghe(modeDelegante: boolean, anno: string): Observable<Delega[]> {
    let path = 'deleghe/delegato/';
    if (modeDelegante) {
      path = 'deleghe/delegante/';
    }
    return this.http.get(path + this.userService.getDocenteCorrente().id + '/' + anno).pipe (
        map(r => this.parseDelegaResponse(r)),
        catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      }));
  }

  rimuoviDelega(delega: Delega): Observable<any> {
    return this.http.delete(`deleghe/${delega.id}`,  this.optionsContJson)
      .pipe(map(r => { }));
  }


  creaRilevazioneDaAR(ar: AttivitaReale, minuti: number, idDocente: number,  usePreviousYear: boolean,
                      coords: Coordinates, note: string, istanteCreazione: Date, modalita: ModalitaErogazione, 
                      tipoAttivita: string, tipoAttivitaDesc: string): Observable<Rilevazione> {
    const rilevazione: Rilevazione = {
      id: null,
      iul: null,
      idAttivitaReale: ar.id,
      idDocente: idDocente,
      durata: minuti,
      note: note,
      istanteCreazione: istanteCreazione,
      usePreviousYear: usePreviousYear,
      modalitaErogazione: modalita,
      tipoAttivita: tipoAttivita,
      tipoAttivitaDesc: tipoAttivitaDesc
    };

    if (coords) {
      rilevazione.latitudine = coords.latitude;
      rilevazione.longitudine = coords.longitude;
    }

    return this.creaRilevazione(rilevazione);
  }

  creaRilevazione(rilevazione: Rilevazione): Observable<Rilevazione> {
    return this.http.put('rilevazioni/', JSON.stringify(rilevazione),  this.optionsContJson)
      .pipe(map(r => this.parseRilevazioneResponse(r, false).pop()));
  }

  creaRilevazioneDaToken(): Observable<Rilevazione> {
    return this.http.get('rilevazioni/usetoken')
      .pipe(map(r => this.parseRilevazioneResponse(r, false).pop()),
      catchError(error => {
       if (error.status === 404) {
         return of(undefined);
       } else {
        // throwError(() => new Error(error));
        throw(error);
      }
     }));
  }

  incongruenza(p: Presenza): boolean {
    if (this.configService.indicaErogazioneFruizione && p) {
      if (p.rilevazione && p.modalitaFruizione && p.rilevazione.modalitaErogazione) {
        if (p.rilevazione.modalitaErogazione !== ModalitaErogazione.IBRIDA) { // con modalità ibrida non c'è mai incongruenza
          return p.rilevazione.modalitaErogazione!==p.modalitaFruizione;
        }
      }
    }
    return false;
  }

  updateRilNotes(rilevazione: Rilevazione): Observable<any> {
    rilevazione.ar.rilevazioni = null; // per evitare riferimenti circolari
    return this.http.put(`rilevazioni/updnote`, JSON.stringify(rilevazione), this.optionsContJson)
      .pipe(map(r => this.parseRilevazioneResponse(r).pop()));
  }

  updateRilAddress(rilevazione: Rilevazione): Observable<any> {
    rilevazione.ar.rilevazioni = null; // per evitare riferimenti circolari
    return this.http.put(`rilevazioni/updaddress`, JSON.stringify(rilevazione), this.optionsContJson)
      .pipe(map(r => this.parseRilevazioneResponse(r).pop()));
  }

  rimuoviRilevazione(rilevazione: Rilevazione): Observable<any> {
    return this.http.delete(`rilevazioni/${rilevazione.id}`,  this.optionsContJson)
      .pipe(map(r => { }));
  }

  concludi(rilevazione: Rilevazione): Observable<any> {
    return this.http.post(`rilevazioni/${rilevazione.id}/concludi`,  this.optionsContJson)
      .pipe(map(r => this.parseRilevazioneResponse(r).pop()));
  }

  countPresenze(rilevazione: Rilevazione): Observable<number> {
    return this.http.get<string>(`presenze/rilevazione/${rilevazione.id}/count`)
     .pipe(map(r => parseInt(r, 10)));
  }

  countPresenzeGeolocalizzate(rilevazione: Rilevazione): Observable<number> {
    return this.http.get<string>(`presenze/rilevazione/${rilevazione.id}/geolocalized/count`)
     .pipe(map(r => parseInt(r, 10)));
  }

  countPresenzeNonSegnalate(rilevazione: Rilevazione): Observable<number> {
    return this.http.get<string>(`presenze/rilevazione/${rilevazione.id}/presenti/count`)
    .pipe(map(r => parseInt(r, 10)));
  }

  getConteggiRilevazione(rilevazione: Rilevazione): Observable<ConteggiRilevazione> {
    return this.http.get<ConteggiRilevazione>(`presenze/rilevazione/conteggi/${rilevazione.id}`);
  }


  aggiornamentoPresenze(rilevazione: Rilevazione): Observable<any> {
    return this.http.get<Rilevazione>(`presenze/rilevazione/${rilevazione.id}/v2/aggiornamento`);
      // .pipe(map(r => JSON.parse(r..text())));
  }

  getPresenze(rilevazione: Rilevazione): Observable<Presenza[]> {
    return this.http.get(`presenze/rilevazione/${rilevazione.id}`)
      // .pipe(map(r => r.json() as Presenza[])
      .pipe(map(r => this.parsePresenzeResponse(r)));
  }

  getPresenzeStudente(s: Studente, anno: string): Observable<Presenza[]> {
    return this.http.get(`presenze/studente/${s.id}/${anno}`)
      // .pipe(map(r => r.json() as Presenza[])
      .pipe(map(r => this.parsePresenzeResponse(r)));
  }

  getPresenzeAR(ar: AttivitaReale): Observable<Presenza[]> {
    // console.log('ar.id', ar.id);
    return this.http.get(`presenze/ar/${ar.id}`)
      .pipe(map(r => this.parsePresenzeResponse(r)));
  }

  countStudentiAR(ar: AttivitaReale): Observable<number> {
    return this.http.get<string>(`presenze/ar/${ar.id}/count`)
    .pipe(map(r => parseInt(r, 10)));
  }


  countStudentiMultipleAR(ars: AttivitaReale[]): Observable<number> {
    let queryParams = 'ids=';
    ars.forEach(el => { queryParams += `${el},`; });
    queryParams = queryParams.slice(0, -1);
    return this.http.get<string>(`presenze/ars/count?${queryParams}`)
    .pipe(map(r => parseInt(r, 10)));
  }

  getPresenzaStudente(s: Studente, l: Rilevazione): Observable<Presenza[]> {
    return this.http.get(`presenze/studente/${s.id}/ril/${l.id}`)
      .pipe(map(r => this.parsePresenzeResponse(r)));
  }

  verificaLibrettoAttiva(): Observable<number> {
    return this.http.get<string>('rilevazioni/studente/verificalibretto')
      .pipe(map(r => parseInt(r, 10)));
  }

  countRilevazioniAttiveGeolocalizzate(): Observable<number> {
    return this.http.get<string>('rilevazioni/studente/geolocalizzate/active/count')
      .pipe(map(r => parseInt(r, 10)));
  }

  cercaRilevazioniUtilizzabili(s: Studente): Observable<Rilevazione[]> {
    console.log('cercaRilevazioniUtilizzabili');
    const loadAddress = true;
    return this.http.get('rilevazioni/studente/' + s.id + '/utilizzabili')
      .pipe(map(r => this.parseRilevazioneResponse(r, loadAddress)),
            catchError(error => {
              if (error.status === 404) {
                return of(undefined);
              } else {
                // non capisco perché far arriare l'errore all'utente finale ...
                // throwError(() => new Error(error));
                console.log('ATTENZIONE, errore non gestito del be', error);
                return of(undefined);
              }
            }));
  }

  /**
   * aggiunta della presenza da parte di uno studente
   */
  aggiungiPresenza(s: Studente, l: Rilevazione, coords?: Coordinates, assenza?: boolean, moderoglezione?: string): Observable<Presenza> {

    const modalita = this.getModalita(moderoglezione) ;

    const p: any = {
      idRilevazione: l.id,
      idStudente: s.id,
      matricola: s.matricola,
      modalitaFruizione: modalita
    };

    if (coords) {
      p['latitudine'] = coords.latitude;
      p['longitudine'] = coords.longitude;
      p['accuracy'] = coords.accuracy;
    }
    const url = assenza ? `presenze/${s.id}/assenza` : `presenze/${s.id}`;
    return this.http.put(url, JSON.stringify(p), this.optionsContJson)
      .pipe(map(r => this.parsePresenzeResponse(r).pop()));
  }

  getModalita(md: string): ModalitaErogazione {
    let ret = ModalitaErogazione.IN_PRESENZA;
    switch (md) {
      case 'i':
        ret = ModalitaErogazione.IBRIDA;
        break;
      case 'p':
        ret = ModalitaErogazione.IN_PRESENZA;
        break;
      case 'r':
        ret = ModalitaErogazione.DA_REMOTO;
        break;
      }
      return ret;
  }
  decodeModalita(md: ModalitaErogazione): string {
    let ret = 'p';
    switch (md) {
      case ModalitaErogazione.IBRIDA:
        ret = 'i';
        break;
      case ModalitaErogazione.IN_PRESENZA:
        ret = 'p';
        break;
      case ModalitaErogazione.DA_REMOTO:
        ret = 'r';
        break;
      }
      return ret;
  }

  aggiungiPresenzaOperatoreNew(p: Presenza): Observable<Presenza> {
    return this.http.put('presenze/', JSON.stringify(p), this.optionsContJson)
      .pipe(map(r => this.parsePresenzeResponse(r).pop()));
  }

  /**
   * aggiunta della presenza da parte di un operatore (docente o pta)
   */

  aggiungiPresenzaOperatore(s: Studente, l: Rilevazione, u: Utente, om?: string, assenza?: boolean): Observable<Presenza> {

    let stato = StatoPresenza.PRESENZA;
    if (assenza) {
      stato = StatoPresenza.ASSENZA;
    }
    const p: any = {
      idRilevazione: l.id,
      idStudente: s.id,
      matricola: s.matricola,
      idOperatore: u.id,
      istanteMarcatura: om,
      stato: stato
    };

    return this.http.put('presenze/', JSON.stringify(p), this.optionsContJson)
      .pipe(map(r => this.parsePresenzeResponse(r).pop()));
  }

  aggiungiPresenzeOperatore(s: Studente[], l: Rilevazione, u: Utente): Observable<Presenza[]> {

    const p: any[] = [];

    s.forEach(stud => {
      p.push({
        idRilevazione: l.id,
        idStudente: stud.id,
        matricola: stud.matricola,
        idOperatore: u.id
      });
    });

    return this.http.put<Presenza[]>('presenze/multiple', JSON.stringify(p), this.optionsContJson)
    .pipe(catchError(error => {
      if (error.status === 404) {
        return of(undefined);
      } else {
        return EMPTY;
      }
    }));
  }

  modificaPresenza(presenza: Presenza): Observable<Presenza> {
    return this.http.put(`presenze/modifica`, JSON.stringify(presenza), this.optionsContJson)
      .pipe(map(r => this.parsePresenzeResponse(r).pop()));
  }

  verificaPrenotazione(rilevazione: Rilevazione, studente: Studente): Observable<Prenotato>  {
     return this.http.get<Studente>(`presenze/studente/${studente.matricola}/booking/${rilevazione.id}`)
    // return this.http.get<Studente>(`presenze/studente/467271/booking/${rilevazione.id}`)
    .pipe(map(r => this.parsePrenotazioneResponse(r)),
    catchError(error => {
      if (error.status === 404) {
        return of(undefined);
      } else {
        console.log('ATTENZIONE, errore non gestito del be', error);
        return of(undefined);
      }
    }));
  }


  segnalaAbuso(p: Presenza): Observable<Presenza> {
/*    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      }),
      observe: 'response'
     }; */
    // l'update del dato va a buon fine ma non rieco a rileggere la response che nell'interceptor
    // sembra corretta mentre qui risulta null. Per ora commento il controllo sulla response
    // che in potrebbe essere comunque ridondante visto che l'interceptor gestsce eventuali
    // situazioni di errore
    return this.http.post(`presenze/${p.id}/abuso`, this.optionsContJson)
      .pipe(tap((evt: HttpEvent<any>)  => {
          console.log('rr ' + JSON.stringify(evt));
        }),
        map((r: HttpEvent<any>) => {
        // console.log('p.id-r-->' + p.id + '-' + JSON.stringify(r));
          // if (r) { // FIXME era r.ok
          p.stato = StatoPresenza.ABUSO;
          // }
        return p;
      }));
  }

  resetAbuso(p: Presenza): Observable<Presenza> {

    return this.http.post(`presenze/${p.id}/resetAbuso`, this.optionsContJson)
      .pipe(map(r => {
        // console.log('p.id-r-->' + p.id + '-' + JSON.stringify(r));
        // if (r) { // FIXME come per segnala abuso
          p.stato = StatoPresenza.PRESENZA;
        // }
        return p;
      }));
  }


  rimuoviPresenza(p: Presenza): Observable<any> {
    return this.http.delete(`presenze/${p.id}`, this.optionsContJson )
      .pipe(map(r => { }));
  }

  rimuoviPresenze(p: Presenza[]): Observable<any> {
    const pId: number[] = [];
    p.forEach(pres => { pId.push(pres.id); });
    let queryParams = '';

    pId.forEach(el => { queryParams += `presenza=${el}&`; });
    return this.http.delete(`presenze/tutti` + `?` + queryParams)
      .pipe(map(r => { }));
  }

/**
 * invio delle notifiche
 *
 * il parametro oggetto è facoltativo, se non valorazzato viene impostato
 * il default (chiave invio-notifica.default.subject delle risorse localizzate)
 */
  inviaNotifica(rilevazione: Rilevazione, messaggio: string, oggetto?: string): Observable<any> {

    if (!messaggio || !rilevazione) {
      console.log('impossibile inviare la notifica: parametri mancanti');
      return;
    }

    if (!oggetto) {
      oggetto = this.translateService.instant('invio-notifica.default.subject');
    }

    // let docente = this.userService.getDocenteCorrente().cognome;
    const tag = `rilevazione_${rilevazione.id}`;
    const post = `{
      "subject": "${oggetto}",
      "body": "${messaggio}",
      "pushes": [
          { "appId":"${this.envService.ONESIGNAL_ID}","tags" : "${tag}=true" }
        ]
    }`;

    return this.http.post(`notifiche/invio`, post, this.optionsContJson)
      .pipe(map(r => {
        return r; // FIXME era r.ok
      }));
  }

  /**
   * corsi
   */
  cercaCorsi(corso: string, anno: string): Observable<Corso[]> {
    return this.http.get('corsi/' + corso + '/' + anno)
      .pipe(
        map(r => this.parseCorsoResponse(r)),
        catchError(error => {
          if (error.status === 404) {
            return of(undefined);
          } else {
            throwError(() => new Error(error));
          }
        })
      );
  }

  private parseCorsoResponse(response: any): Corso[] {

    const json = response; // .json();

    if (json) {
      const data: Corso[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toCorsiSmart(data);
      return data;
    } else {
      throw response;
    }
  }

  /**
   * aggiunge l'implementazione dei metodi di business
   */
  public toCorsiSmart(corsi: Corso[]) {
    for (const f of corsi) {

    }
  }

  /**
   * studenti
   */

  public toStudentiSmart(studenti: Studente[]) {
    for (const s of studenti) {
      this.toStudenteSmart(s);
    }
  }

  public toStudenteSmart(s: Studente) {
    if (!this.configService.showStudentName) {
      s.nome = '';
    };
  }
      
  public parseStudentiResponse(response: any): Studente[] {

    const json = response; // .json();
    if (json) {
      // console.log('presenze', json);
      const data: Studente[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toStudentiSmart(data);
      return data;
    } else {
      throw response;
    }
  }

  cercaStudente(matricola: string): Observable<Studente> {
    // let mat = encodeURIComponent(matricola);
    return this.http.get<Studente>('studenti/matricola' + '?matricola=' + matricola)
      .pipe(
        map(s => this.parseStudentiResponse(s).pop()),
        catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      }));
  }

  cercaStudenteCarriere(matricola: string): Observable<Studente[]> {
    return this.http.get<Studente[]>('studenti/matricola/carriere' + '?matricola=' + matricola)
      .pipe(
        map(s => this.parseStudentiResponse(s)),
        catchError(error => {
        if (error.status === 404) {
          return of([]);
        } else {
          return throwError(() => new Error(error));
        }
      }));
  }

  cercaStudenti(matricole: string[]): Observable<Studente[]> {

    return this.http.put<Studente[]>('studenti/matricole', JSON.stringify(matricole), this.optionsContJson)
      .pipe(
        map(s => this.parseStudentiResponse(s)),
        catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          return throwError(() => new Error(error));
        }
      }));
  }

  cercaStudentePerCF(cf: string): Observable<Studente> {
    return this.http.get<Studente>('studenti/codicefiscale/' + cf)
    .pipe(
      map(s => this.parseStudentiResponse(s).pop()));
      // .pipe(map(r => r.json()));
  }

  cercaStudenteIscrInfoPerId(id: any): Observable<StudenteIscrInfo> {
    return this.http.get<StudenteIscrInfo>('studenti/' + id + '/iscrinfo');
      // .pipe(map(r => this.parseStudenteIscrInfo(r));
  }

  cercaStudentePerId(id: any): Observable<Studente> {
    return this.http.get<Studente>('studenti/' + id)
    .pipe(
      map(s => this.parseStudentiResponse(s).pop()));
  }

  /**
   * docenti
   */
  cercaDocentePerCF(cf: string): Observable<Docente[]> {
    return this.http.get('docenti/codicefiscale/' + cf)
      .pipe(map(r => this.parseDocenteResponse(r)),
            catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throw(error);
        }
      }));
  }

  cercaDocentePerCognome(cognome: string, all = 'ALL'): Observable<Docente[]> {
    return this.http.get('docenti/cognome/' + cognome + '/' + all)
      .pipe(map(r => this.parseDocenteResponse(r, true)),
            catchError(error => {
              if (error.status === 404) {
                return of(undefined);
              } else {
                throwError(() => new Error(error));
              }
            }
      ));
  }

  verificaIntegrazioneUpAttivaObs(): Observable<number> {
    return this.http.get<string>('docenti/impegni/verifica')
    .pipe(map(r => parseInt(r, 10)));
 }

 verificaIntegrazioneUpAttiva(): Promise<number> {
  return new Promise((resolve, reject) => {
    this.verificaIntegrazioneUpAttivaObs().subscribe(
      n => resolve( n ), err => reject(err)
    );
  });
}

verificaIntegrazioneSbAttiva(): Observable<number> {
  return this.http.get<string>('rilevazioni/booking/verifica')
 .pipe(map(r => parseInt(r, 10)));
}

getPrenotati(rilevazione: Rilevazione): Observable<Prenotato[]> {
  return this.http.get<Studente[]>(`rilevazioni/${rilevazione.id}/booking`)
   .pipe(map(r => this.parsePrenotazioniResponse(r)),
   catchError(error => {
     if (error.status === 404) {
       return of(undefined);
     } else {
       console.log('ATTENZIONE, errore non gestito del be', error);
       return of(undefined);
     }
   }));
}

countPrenotati(rilevazione: Rilevazione): Observable<number> {
  return this.http.get<string>(`rilevazioni/${rilevazione.id}/booking/count`)
   .pipe(map(r => parseInt(r, 10)));
}

creaImpegno(impegno: ImpegnoDocente, ril: Rilevazione): Observable<ImpegnoDocente> {
  console.log(' impegno.evento ',  impegno.evento);
   const post = {
    'idImpegno': impegno.id,
    'idEvento': impegno.evento._id,
    'extCodeEvento': impegno.evento.extCode,
    'dataInizioFromUP': impegno.dataInizio,
    'dataFineFromUP': impegno.dataFine,
    'extCodeAula': impegno.aula ? impegno.aula.extCode : null,
    'descAula': impegno.aula ? impegno.aula.descrizione : null,
    'extCodeEdificio': impegno.edificio ? impegno.edificio.codice : null,
    'descEdificio': impegno.edificio ? impegno.edificio.descrizione : null,
    'iul': ril.iul,
    'latitudine': impegno.edificio && impegno.edificio.geo ? impegno.edificio.geo.lat : null,
    'longitudine': impegno.edificio && impegno.edificio.geo ? impegno.edificio.geo.lng : null,
    'tipoAttivita': impegno.codTipoAttivita
  };

  console.log('impegno post', post);

  return this.http.put('impegni/', JSON.stringify(post), this.optionsContJson)
    .pipe(map(r => this.parseImpegnoResponse(r).pop()));

}


/**
  * parsing della risposta e aggiunta di eventuali metodi di businness
  */
 private parseImpegnoResponse(response: any): ImpegnoDocente[] {
  const json = response; // .json();
  if (json) {
    const data: ImpegnoDocente[] = (Array.isArray(json)) ? json : Array.of(json);
    this.toImpegnoSmart(data);
    return data;
  } else {
    throw response;
  }
}

private parsePrenotazioniResponse(response: any): Prenotato[] {
  console.log('parsePrenotazioniResponse', response);
  const json = response; // .json();
  if (json) {
    const data: any[] = (Array.isArray(json)) ? json : Array.of(json);
    return this.toPrenotazioniSmart(data);
  } else {
    throw response;
  }
}

private parsePrenotazioneResponse(response: any): Prenotato {
  console.log('parsePrenotazioneResponse', response);
  const json = response; // .json();
  if (json) {
    // const data: any[] = (Array.isArray(json)) ? json : Array.of(json);
    const data = json;
    return this.toPrenotazioneSmart(data);
  } else {
    throw response;
  }
}
/**
 * aggiunge l'implementazione dei metodi di business
 */
public toImpegnoSmart(impegni: ImpegnoDocente[]) {
  for (const i of impegni) {
    // console.log('impegno', i);
  }
}

// public toPrenotazioneSmart(prenotazioni: Studente[]): Prenotato[] {
//   const result: Prenotato[] = [];
//   for (const stud of prenotazioni) {
//     console.log('prenotazione', stud);
//     const pr: Prenotato = { id: 0 , idRilevazione: 0, stato: StatoPresenza.PRESENZA, idStudente: 0};
//     pr.studente = stud;

//     pr.descrizione = function () {
//       // return (this.studente) ? this.studente.cognome + " " + this.studente.nome + " " + this.id : "N.D."
//        return (stud) ? stud.cognome + ' ' + stud.nome : 'N.D.' ;
//     };
//     result.push(pr);
//   }

public toPrenotazioneSmart(stud: Studente): Prenotato {
    const pr: Prenotato = { id: 0 , idRilevazione: 0, stato: StatoPresenza.PRESENZA, idStudente: 0};
    pr.studente = stud;

    if (this.configService.showStudentName) {
      pr.descrizione = function () {
        return (stud) ? stud.cognome + ' ' + stud.nome : 'N.D.' ;
      };
    } else {
      pr.descrizione = function () {
        return (stud) ? stud.cognome : 'N.D.' ;
      };
    }
    return pr;
  }

  public toPrenotazioniSmart(prenotazioni: Studente[]): Prenotato[] {
    const result: Prenotato[] = [];
    for (const stud of prenotazioni) {
      console.log('prenotazione', stud);
      const pr: Prenotato = this.toPrenotazioneSmart(stud);
      result.push(pr);
    }

    console.log('prenotati smart', result);
  return result;
}

  // recuperaImpegniDocente(matricola: string): Observable<ImpegnoDocente[]> {
  //     return this.http.get<ImpegnoDocente[]>('docenti/impegni/' + matricola);
  // }

  cercaDocentePerMatricola(matricola: string): Observable<Docente[]> {
    return this.http.get('docenti/matricola/' + matricola)
      .pipe(map(r => this.parseDocenteResponse(r)),
            catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(() => new Error(error));
        }
      }));
  }

  private parseDocenteResponse(response: any, addMatricola: boolean = false): Docente[] {
    const json = response; // .json();
    if (json) {
      const data: Docente[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toDocentiSmart(data, addMatricola);
      return data;
    } else {
      throw response;
    }
  }

  formatta(date) {
    console.log('date', date);
    const fdate =  format(date, 'yyyy-MM-dd' + '\'T\'' + 'HH:mm');
    console.log('formatted date', fdate);
    return fdate;
  }

  /**
   * aggiunge l'implementazione dei metodi di business
   */
  public toDocentiSmart(docenti: Docente[], addMatricola: boolean = false) {
    for (const f of docenti) {
      // il backend può restituire il docente a null (es. rilevazione senza docente associato)
      if (!f) {
        continue;
      }
      f.nominativo = f.cognome + ' ' + f.nome;
      if (addMatricola) {
        f.nominativo = f.nominativo + ' (' + f.id + ')';
      }
    }
  }

  public toDocenteSmart(docente: Docente, addMatricola: boolean = false) {
    const docs: Docente[] = [docente];
    return this.toDocentiSmart(docs, addMatricola);
  }
  /**
   * aggiunge l'implementazione dei metodi di business
   */
  public toRilevazioniSmart(rilevazioni: Rilevazione[], loadAddress = false) {
    for (const rilevazione of rilevazioni) {
      rilevazione.titolo = function () {
        return (this.ar) ? this.ar.descrizione : 'N.D.';
      };
      rilevazione.sottoTitolo = function () {
        return (this.docente) ? 'Docente: ' + this.docente.cognome + ' ' + this.docente.nome : 'N.D.';
      };
      rilevazione.conclusa = function () {
        return this.stato === StatoRilevazione.CONCLUSA;
      };

      rilevazione.docenteDelegato = function () {
        return (this.delegato) ? 'Delegato: ' + this.delegato.cognome + ' ' + this.delegato.nome : undefined;
      };
      if (rilevazione.delega) {
        const arr = [rilevazione.delega];
        this.toDelegaSmart(arr);
      }

      if ( !rilevazione.address && loadAddress && rilevazione.latitudine && rilevazione.longitudine ) {
        if (this.platform.is(PlatformName)) {
          this.geolocUtilityService.getAddressMobile(rilevazione.latitudine, rilevazione.longitudine, (address) => {
            rilevazione.address = address;
            console.log('address (native) ', address);
          });
        } else {
          this.geolocUtilityService.getAddressBrowser(rilevazione.latitudine, rilevazione.longitudine, (address) => {
            rilevazione.address = address;
            console.log('address (web)', address);
          });
        }
      }

      // durataReale è la durata calcolate in base alla chiusura anticipata
      // viene formattata in durataRealeF
      rilevazione.durataRealeF = this.utilityService.formatDurata(rilevazione.durataReale);

      if (this.configService.getConfigurazione(
        ChiaveConfig.VAL_ORE_ACCADEMICHE) !== 60 && rilevazione.ar) {
          if (rilevazione.ar.cds.length !== 0) {
            if (this.cdsList.includes(rilevazione.ar.cds[0].id) && rilevazione.durata >= 60) {
              if (rilevazione.durataReale % 60 !== 0) {
                rilevazione.durataRealeF = this.utilityService.formatDurata(
                  (((rilevazione.durataReale - rilevazione.durataReale % 60) / 60) *
                  this.configService.getConfigurazione(ChiaveConfig.VAL_ORE_ACCADEMICHE)) + rilevazione.durataReale % 60);
              } else {
                rilevazione.durataRealeF = this.utilityService.formatDurata((rilevazione.durataReale / 60) *
                this.configService.getConfigurazione(ChiaveConfig.VAL_ORE_ACCADEMICHE));
              }
            }
          }
        }

      // durataF è le stringa formattata che rappresenta la durata originale con cui è stata definita la rilevazione
      rilevazione.durataF = this.utilityService.formatDurata(rilevazione.durata);

      // console.log('rilevazione.IUL', rilevazione.iul);
      // console.log('do', rilevazione.durataF);
      // console.log('dr', rilevazione.durataRealeF);

    }
  }

  addMinutes(date, minutes): Date {
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }
  /**
   * parsing della risposta e aggiunta di eventuali metodi di businness
   */
  private parseRilevazioneResponse(response: any, loadAddress = false): Rilevazione[] {
    const json = response; // .json();
    if (json) {
      const data: Rilevazione[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toRilevazioniSmart(data, loadAddress);
      // return (Array.isArray(json)) ? data : data[0];
      return data;
    } else {
      // return this.handleError(response);
      throw response;
    }
  }

  /**
   * aggiunge l'implementazione dei metodi di business
   */
  public toPresenzeSmart(presenze: Presenza[]) {
    for (const f of presenze) {
      this.toPresenzaSmart(f);
    }
  }

  public toPresenzaSmart(f: Presenza) {
      if (this.configService.showStudentName) {
        f.descrizione = function () {
          return (this.studente) ? this.studente.cognome + ' ' + this.studente.nome : 'N.D.' ;
        };
      } else {
        f.descrizione = function () {
          this.studente.nome = '';
          return (this.studente) ? this.studente.cognome : 'N.D.' ;
        };
      }

      /*
      f.precentualeVerifica = function () {
        let verificaPresenze:string = "";
        if (this.richiesteDiConferma > 0) {
          verificaPresenze = (this.confermeDiPresenza>0 ?  this.confermeDiPresenza: "0") + "/" + this.richiesteDiConferma;
        }
        return verificaPresenze;
      };
      */

    // FINE RIMUOVERE RIMUOVERE RIMUOVERE RIMUOVERE RIMUOVERE RIMUOVERE
      f.confermata = function () {
        if (this.richiesteDiConferma > 0) {
          return this.confermeDiPresenza === this.richiesteDiConferma;
        } else {
          return undefined;
        }
      };

      if (f.rilevazione) {
        this.toRilevazioniSmart([f.rilevazione]);
      }
  }

  /**
   * parsing della risposta e aggiunta di eventuali metodi di businness
   */
  public parsePresenzeResponse(response: any): Presenza[] {

    const json = response; // .json();
    if (json) {
      // console.log('presenze', json);
      const data: Presenza[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toPresenzeSmart(data);
      return data;
    } else {
      throw response;
    }
  }


  public parseRichiesteGiustifica(response: any): AbscenceJustificationModel[] {

    const json = response; // .json();
    if (json) {
      // console.log('presenze', json);
      const data: AbscenceJustificationModel[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toRichiesteGiustificaSmart(data);
      return data;
    } else {
      throw response;
    }
  }

  public toRichiesteGiustificaSmart(richiesteGiustifica: AbscenceJustificationModel[]) {
    for (const f of richiesteGiustifica) {
      this.toRichiestaGiustificaSmart(f);
    }
  }

  public toRichiestaGiustificaSmart(richiestaGiustifica: AbscenceJustificationModel) {
  /**
    * parsing della risposta e aggiunta di eventuali metodi di businness
    */
      if (richiestaGiustifica.rilevazione) {
        this.toRilevazioniSmart([richiestaGiustifica.rilevazione]);
        this.toDocenteSmart(richiestaGiustifica.rilevazione.docente);
      }
  }

  private parseDelegaResponse(response: any): Delega[] {

    const json = response; // .json();

    if (json) {
      const data: Delega[] = (Array.isArray(json)) ? json : Array.of(json);

      this.toDelegaSmart(data);

      // return (Array.isArray(json)) ? data : data[0];
      return data;
    } else {
      throw response;
    }

  }

  /**
   * aggiunge l'implementazione dei metodi di business
   */
  public toDelegaSmart(deleghe: Delega[]) {
    for (const d of deleghe) {
      d.titolo = function () {
        return (this.ar) ? this.ar.descrizione : 'N.D.';
      };
      d.sottoTitolo = function () {
        return (this.docente) ? 'Docente: ' + this.docente.cognome + ' ' + this.docente.nome : 'Docente: N.D.';
      };
      d.docenteDelegato = function () {
        return (d.delegato) ? 'Delegato: ' + d.delegato.cognome + ' ' + d.delegato.nome : undefined;
      };

      if (d.rilevazione) {
        this.toRilevazioniSmart([d.rilevazione]);
      }
    }
  }



  parsePresenze(attivitaReale: AttivitaReale, usaOreAD: boolean): StudenteEnanche[] {
    const studenti: any[] = [];
    let abusoAsAssenzaFilter = this.configService.getConfigurazione(ChiaveConfig.ABUSO_AS_ASSENZA_FILTER);
    // definisce la funzione che esegue il raggruppamento in base ad un attributo
    const groupBy = (key) => array =>
      array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {});
      const groupByIdStudente  = groupBy('idStudente');
      // raggruppa l'array
      const presGroupedByStudId = groupByIdStudente(attivitaReale.presenze);
      // console.log(JSON.stringify({studsByIdStudente: presGroupedByStudId,  }, null, 2));
      // tslint:disable-next-line:forin
      for (const studId in presGroupedByStudId) {
        let stud: Studente;
        if (presGroupedByStudId.hasOwnProperty(studId)) {
          // const npres = presGroupedByStudId[studId].length; // non è sufficiente il totale
          // ho bisogno del totale in ore, la durata delle rilevazioni varia
          // conta e somma il totale delle durate 
          let nStudPres = 0;
          let suddivisioneOre = [];
          const studTotPres = presGroupedByStudId[studId].reduce((sum: number, presenza: Presenza) => {
            if(abusoAsAssenzaFilter === 'false') {
              if (presenza.stato === StatoPresenza.PRESENZA || presenza.stato === StatoPresenza.ABUSO ||
                (presenza.stato === StatoPresenza.ASSENZA && presenza.giustificata)  ) {
                nStudPres = nStudPres + 1 ;
              }
            }
            else {
              if (presenza.stato === StatoPresenza.PRESENZA ||
                (presenza.stato === StatoPresenza.ASSENZA && presenza.giustificata)  ) {
                nStudPres = nStudPres + 1 ;
              }
            }
            console.log('pr' , presenza.rilevazione);
            // inizializza la suddivisione ore dello stud, se necessario
            if (attivitaReale.suddivisioneOre?.length > 0 && suddivisioneOre.length === 0) {
              suddivisioneOre = this.utilityService.cloneSuddivisione(attivitaReale.suddivisioneOre);
            }
            if (suddivisioneOre && presenza.rilevazione.tipoAttivita) {
              // incrementa le ore "erogate" con quelle frequentate dello studente, 
              const oreTA = suddivisioneOre.find(sudd => sudd.cod === presenza.rilevazione.tipoAttivita);
              if (oreTA) {
                oreTA.minFruiti += presenza.durata;
              }
            }
            sum = sum + presenza.durata;
            // console.log('idStudente', presenza.idStudente);
            // console.log('matricola', presenza.matricola);
            // console.log('presenza', presenza);
            // console.log('sum', sum );
            stud = presenza.studente;
            if (!this.configService.showStudentName ) {
              stud.nome = '';
            }
            return sum;
          }, 0);
          suddivisioneOre = this.utilityService.aggiornaSuddivisioni(suddivisioneOre);
          
          let frequenza = studTotPres / attivitaReale.totaleMinuti;
          if (usaOreAD) { // solo per l'idoneità di frequenza. Negli storici viene usato l'erogato del docente
            if (attivitaReale.ore && attivitaReale.ore > 0) {
              frequenza = studTotPres / (attivitaReale.ore * 60);
            }
          }
      // console.log('frequenza', frequenza);
          studenti.push( { studente: stud ,
                           freqinfo: { npres: nStudPres, totpres: studTotPres,
                                    frequenza: frequenza , assenza: 1 - frequenza,
                       // idoneita (boolean) e idoneitadoc (number nullable) vengono recuperai dal db, tabella idoneita_studenti
                                    idoneita: false , idoneitadoc: undefined,
                                    libretto: false , suddivisioneOre: suddivisioneOre} ,
                           presenze: presGroupedByStudId[studId]} );
        }
      }
      this.utilityService.orderBy( { field: 'cognome', ascdesc: 'asc'}, studenti);
      // utile per limitare in debug l'elenco di stud a video 
      // studenti = studenti.filter(stud => {
      //   return (stud.studente.matricola === '858330');
      // });
      return studenti;

  }

  // private parseStudenteIscrInfo(response: any): StudenteIscrInfo[] {
  //   const json = response; // .json();
  //   if (json) {
  //     const data: StudenteIscrInfo[] = (Array.isArray(json)) ? json : Array.of(json);
  //     this.toStudenteIscrInfoSmart(data);
  //     return data;
  //   } else {
  //     throw response;
  //   }
  // }

    /**
   * aggiunge l'implementazione dei metodi di business

  public toStudenteIscrInfoSmart(studenteIscrInfo: StudenteIscrInfo[]) {
    for (const f of studenteIscrInfo) {
     f.tipoIscr =
      this.translateService.instant(
        'rilevazione-presenze-service.label.tipo-iscrizione.' + f.tipoIscrCod);
    }
  }
    */

  creaAssenze(rilevazioni: Rilevazione[], s: Studente, presenze: Presenza[], justifications: AbscenceJustificationModel[]): Presenza[] {
    console.log('creaAssenze rilevazioni', rilevazioni );
    const assenze: Array<Presenza> = [] ;
    for (const r of rilevazioni) {
      const presenza = presenze.filter(p => p.rilevazione.id === r.id );
      if (presenza.length === 0) {
        assenze.push(this.generaAssenza(r, s, justifications.find(j => j.idRilevazione === r.id)));
      } else {
        // se trova la presenza verifica che non si tratti di un assenza registrata e non giustificata e in tal caso
        // ne imposta l'id a 0 per farla risultare come assenza
        if (presenza[0].stato === StatoPresenza.ASSENZA && !presenza[0].giustificata) {
          presenza[0].id = 0;
          presenza[0].giustificazione = justifications.find(j => j.idRilevazione === r.id);
        }
        if (presenza[0].stato === StatoPresenza.ASSENZA && presenza[0].giustificata) {
          presenza[0].giustificazione = justifications.find(j => j.idRilevazione === r.id);
        }

      }
    }
    console.log('creaAssenze assenze', assenze );
    this.toPresenzeSmart(assenze);
    return assenze;
  }

  generaAssenza(r: Rilevazione, s: Studente, justification?: AbscenceJustificationModel): Presenza {
    const p: Presenza = { id: 0,
      istanteMarcatura: r.istanteCreazione,
      idRilevazione: r.id ,
      idStudente: s.id,
      stato: StatoPresenza.ASSENZA,
      rilevazione: r,
      giustificazione: justification
    };
    return p;
  }

  eraPresente(r: Rilevazione,  ids: number[]): boolean {
    return ids.indexOf(r.id) !== -1;
  }

  segnalaAssenza(p: Presenza): Observable<Presenza> {
    return this.http.post(`presenze/${p.id}/assenza`, this.optionsContJson)
      .pipe(map(r => {
          // console.log('p.id-r-->' + p.id + '-' + JSON.stringify(r));
          p.stato = StatoPresenza.ASSENZA;
        return p;
      }));
  }

  resetAssenza(p: Presenza) {
    return this.http.post(`presenze/${p.id}/resetAssenza`, this.optionsContJson)
      .pipe(map(r => {
          // console.log('p.id-r-->' + p.id + '-' + JSON.stringify(r));
          p.stato = StatoPresenza.PRESENZA;
        return p;
      }));
  }

  segnalaUscita(p: Presenza): Observable<Presenza> {
    return this.http.post(`presenze/${p.id}/uscita`, this.optionsContJson)
    .pipe(map(r => this.parsePresenzeResponse(r).pop()));
  }

  cercaRichiesteGiustifica(filter):  Observable<AbscenceJustificationModel[]> {
    const da = filter.dataDa || '';
    const a = filter.dataA || '';
    const idAr = filter.idAr || '';
    const matricola = filter.matricola || '';
    const anno = filter.anno || '';

    const url = `richiestegiustifica?anno=${anno}&dataDa=${da}&dataA=${a}&idAr=${idAr}&matricola=${matricola}`;
    return this.http.get(url)
      .pipe(map(r => this.parseRichiesteGiustifica(r)));
  }

  getRichiesteGiustifica(ar: AttivitaReale, st: Studente):  Observable<AbscenceJustificationModel[]> {
    const idAr = ar.id.split(':')[1];
    const url = `richiestegiustifica/${idAr}/${st.id}`;
    return this.http.get(url)
      .pipe(map(r => this.parseRichiesteGiustifica(r)));
  }

  putRichiesteGiustifica(p: Presenza, s: Studente, ar: AttivitaReale, motivazione: string ): Observable<AbscenceJustificationModel> {
    let requestBody: AbsenceRequestBodyModel = {
      idRilevazione: p.rilevazione.id,
      idStudente: s.id,
      idAttivitaReale: ar.id,
      motivazione: motivazione
    };
    if (p.giustificazione) {
      requestBody = p.giustificazione
      requestBody.motivazione = motivazione;
    }
    const url = `richiestegiustifica/${s.id}`;
    const b = JSON.stringify(requestBody);

    return this.http.put(url, b, this.optionsContJson)
      .pipe(map(r => this.parseRichiesteGiustifica(r).pop()));
  }

  
  postRichiesteGiustifica(richiesta: AbscenceJustificationModel, stato: AbsenceRequestStatus): Observable<AbscenceJustificationModel> {
    const url = `richiestegiustifica/${richiesta.idStudente}/${stato}`;
    const b = JSON.stringify(richiesta);

    return this.http.put(url, b, this.optionsContJson)
      .pipe(map(r => this.parseRichiesteGiustifica(r).pop()));
  }

  

  populateStudentProgress(ar: AttivitaReale, freqVsTotAr?: boolean): StudenteProgress {
    const sp: StudenteProgress = {};
    let abusoAsAssenzaFilter = this.configService.getConfigurazione(ChiaveConfig.ABUSO_AS_ASSENZA_FILTER);
    sp.frequenza = ar.durataInMinuti / (ar.totaleMinuti);
    if (freqVsTotAr) {
      sp.frequenza = ar.durataInMinuti / (ar.ore * 60);
    }
    sp.minutipresenza = 0;
    sp.numeropresenze = 0;
    for (const p of ar.presenze) {
      if(abusoAsAssenzaFilter === 'false') {
        if (p.stato === StatoPresenza.PRESENZA || p.stato === StatoPresenza.ABUSO ||
          (p.stato === StatoPresenza.ASSENZA && p.giustificata) ) { 
          sp.minutipresenza += p.durata;
          sp.numeropresenze++;
        }
      }
      else {
        if (p.stato === StatoPresenza.PRESENZA || (p.stato === StatoPresenza.ASSENZA && p.giustificata) ) { 
          sp.minutipresenza += p.durata;
          sp.numeropresenze++;
        }
      }
    }
    sp.minutipresenzaF = this.utilityService.formatDurata(sp.minutipresenza);	 // minuti di presenza dello studente

    sp.numerorilevazioniar = ar.numeroRilevazioni;
    sp.minutitotaliar = ar.totaleMinuti;
    sp.minutitotaliarF = this.utilityService.formatDurata(ar.totaleMinuti);
    console.log('studentProgress', sp);
    return sp;
  }

}
